import {getCups} from "./getCups";

/**
 * Takes tracks from Firestore DB and converts it into a format DisplayCupTracks component renders.
 * @param {Array} tracks an array of tracks pulled from Firestore
 * @see App.js loader for route /browse/cup/:cupid
 * @returns a new array with proper track data rather than raw cup data + original index.
 */
export default function getTracks(tracks) {
    const cups = getCups();

    return tracks.map(element => {
      const index = element.originIndex;
      const currentCup = cups.get(element.cup)
      return { 
        emblem: currentCup.emblem,
        cup: {
          name: element.cup,
          tdgNum: currentCup.tdgNum,
          index: currentCup.index
        },
        name: currentCup.tracks[index].name,
        origin: currentCup.tracks[index].origin,
        image: currentCup.tracks[index].image
      }
    });
  }